<template>
  <div id="servicios">
    <div class="container main-container">
      <div class="row justify-content-center">
        <h1 class="section-title">Servicios</h1>
      </div>
      <div class="row">
        <div class="col">
          <button v-b-modal.modal-1 class="nacional-container button-box">
            <span>Nacional</span>
          </button>
        </div>
        <b-modal size="lg" class="justify-content-center" id="modal-1" hide-footer>
          <div class="d-block text-center">
            <h2 class="modal-title">Nacional</h2>
          </div>
          <b-container>
            <p class="mt-4">
              Gracias al compromiso que tenemos con nuestros clientes,
              hemos crecido en cobertura; abarcando tres cuartas partes de la República Mexicana.
            </p>
            <ul>
              <li>Territorio Nacional</li>
              <li>Aeropuertos (Recinto Aduanero)</li>
            </ul>
            <img src="../assets/RutasNacional.png" alt="rutas" class="w-100 p-3">
          </b-container>
        </b-modal>
      </div>
      <div class="row">
        <div class="col">
          <button v-b-modal.modal-2 class="cruces-container button-box">
            <span>Cruces</span>
          </button>
        </div>
        <b-modal size="lg" class="justify-content-center" id="modal-2" hide-footer>
          <div class="d-block text-center">
            <h2 class="modal-title">Cruces</h2>
          </div>
          <b-container>
            <ul>
              <li>Tijuana</li>
              <li>San Luis Río Colorado</li>
              <li>Mexicali</li>
            </ul>
            <img src="../assets/CrucesServicio.jpeg" alt="rutas" class="w-100 p-3" style="border-radius: 3vh">
          </b-container>
        </b-modal>
      </div>
      <div class="row">
        <div class="col">
          <button v-b-modal.modal-3 class="imp-container button-box">
            <span>Importación - Exportación</span>
          </button>
        </div>
        <b-modal size="xl" class="justify-content-center" id="modal-3" hide-footer>
          <div class="d-block text-center">
            <h2 class="modal-title">Importación - Exportación</h2>
            <video controls autoplay width="100%" class="my-4">
              <source src="../assets/Video.mp4">
            </video>
          </div>
        </b-modal>
      </div>
      <div class="row">
        <div class="col">
          <button v-b-modal.modal-4 class="unidades-container button-box">
            <span>Unidades</span>
          </button>
        </div>
        <b-modal size="lg" class="justify-content-center" id="modal-4" hide-footer>
          <div class="d-block text-center">
            <h2 class="modal-title">Unidades</h2>
          </div>
          <b-card no-body class="overflow-hidden m-4">
            <b-row class="unidad">
              <b-col md="6" class="tractor">
              </b-col>
              <b-col md="6" class="py-2 px-4 unidad-text">
                <h2>Tractor</h2>
                <ul>
                  <li>
                    Toda nuestra flota cuenta con no más de 3 años de antigüedad
                  </li>
                  <li>
                    GPS en todas las unidades
                  </li>
                  <li>
                    Motores DD-15 y DD-13
                  </li>
                </ul>
              </b-col>
            </b-row>
          </b-card>
          <b-card no-body class="overflow-hidden m-4">
            <b-row class="unidad">
              <b-col md="6" class="caja">
              </b-col>
              <b-col md="6" class="py-2 px-4">
                <h2>Caja</h2>
                <ul>
                  <li>
                    53 pies
                  </li>
                  <li>
                    Thermo presedent
                  </li>
                  <li>
                    GPS en todas las unidades
                  </li>
                </ul>
              </b-col>
            </b-row>
          </b-card>
          <b-card no-body class="overflow-hidden m-4">
            <b-row class="unidad">
              <b-col md="6" class="thorton">
              </b-col>
              <b-col md="6" class="py-2 px-4">
                <h2>Thorton</h2>
                <ul>
                  <li>
                    28 pies
                  </li>
                  <li>
                    Flota M2 cuenta con no mas 3 años de antigüedad
                  </li>
                  <li>
                    GPS en todas las unidades
                  </li>
                </ul>
              </b-col>
            </b-row>
          </b-card>


        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
.unidad{
  height: 100%;
}
.tractor{
  background-image: url("../assets/tractor.jpeg");
  background-size: cover;
  background-position: center;
}
.thorton{
  background-image: url("../assets/thorton.jpeg");
  background-size: cover;
  background-position: center;
}
.caja{
  background-image: url("../assets/caja.jpeg");
  background-size: cover;
  background-position: center;
}
.main-container {
  padding-top: 40px;
  padding-bottom: 40px;
}
.button-box{
  width: 100%;
  height: 250px;
  background-size: cover;
  border: 0;
  display: block;
  margin: 20px auto;
  color: #ffffff;
  font-size: 50px;
  letter-spacing: 2px;
  border-radius: 10px;
}
.button-box:hover{
  transition: transform .2s;
  transform: scale(1.05);
}
.button-box:focus{
  border: 0;
  outline: 0;
}
.nacional-container {
  background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url(../assets/Nacional.jpeg) repeat-x 0px -300px;
}
.cruces-container {
  background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url(../assets/Cruces.jpeg) repeat-x 0px -400px;
}
.imp-container {
  background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url(../assets/Exportacion.jpeg) repeat-x 0px -290px;
}
.unidades-container {
  background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url(../assets/Unidades.jpeg) repeat-x 0px -100px;
}
.section-title {
  font-size: 48px;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  margin-bottom: 20px;
}
.modal-title {
  font-size: 38px;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0.1em;
}
.modal-header {
  border-bottom: 0 none;
}
.modal-text {
  text-align: justify;
  margin: 0 20px;
}

@media only screen and (max-device-width: 812px) {
  .tractor{
  background-image: url("../assets/tractor.jpeg");
  background-size: cover;
  background-position: center;
  height: 20vh;
  }
  .thorton{
    background-image: url("../assets/thorton.jpeg");
    background-size: cover;
    background-position: center;
    height: 20vh;
  }
  .caja{
    background-image: url("../assets/caja.jpeg");
    background-size: cover;
    background-position: center;
    height: 20vh;
  }
  .nacional-container {
    background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
      url(../assets/Nacional.jpeg);
    background-size: cover;
    background-position:right;
    font-size: 42px;
  }
  .cruces-container {
    background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
      url(../assets/Cruces.jpeg);
    background-size: cover;
    font-size: 42px;
  }
  .imp-container {
    background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
      url(../assets/Exportacion.jpeg);
    background-size: cover;
    font-size: 42px;
  }
  .unidades-container {
    background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
      url(../assets/Unidades.jpeg);
    background-size: cover;
    font-size: 42px;
  }
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px){
  .nacional-container {
    background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
      url(../assets/Nacional.jpeg) repeat-x 0px -120px;
    background-size: cover;
    font-size: 42px;
  }
  .cruces-container {
    background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
      url(../assets/Cruces.jpeg) repeat-x 0px -120px;
    background-size: cover;
    font-size: 42px;
  }
  .imp-container {
    background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
      url(../assets/Exportacion.jpeg) repeat-x 0px -120px;
    background-size: cover;
    font-size: 42px;
  }
  .unidades-container {
    background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
      url(../assets/Unidades.jpeg) repeat-x 0px -120px;
    background-size: cover;
    font-size: 42px;
  }
}
</style>
